export const theme = {
  color: {
    primary: "#6A67D4",
    primaryDarker: "#4e4ab5",
    second: "rgb(34, 37, 49)",
    third: "#828282",
    fourth: "rgb(239, 242, 245)",
    background: "#F7F7F7",
    backgroundDarker: "rgb(235,235,235)",
    backgroundOpacity: "rgba(0,0,0,0.2)",
    // primaryBackground: "#EAE2FF",

    white: "#fff",
    purple: "#5F2EEA",
    blue: "#007AFF",
    red: "#F8563F",
    orange: "#df9434",
    green: "#5EAF63",
    greenDarker: "#3a8a3f",
    orangeDarker: "#ba7114",
    primaryBackground: "rgba(106, 103, 212, 0.05)",
  },
  font: {
    XXXL: "26px",
    XXL: "22px",
    XL: "20px",
    L: "16px",
    M: "14px",
    S: "12px",
    XS: "10px",
    light: 400,
    normal: 500,
    bold: 600,
    extraBold: 700,
  },
  space: {
    XL: "25px",
    L: "20px",
    M: "15px",
    S: "10px",
    XS: "5px",
  },
  variable: {
    borderRadius: "3px",
    maxWidth: "1600px",
    boxShadow: "0px 0px 25px 0px rgba(0,0,0,0.05)",
  },
}
